<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_vi"></a><span class="small">ALSO BY MICHAEL TOLKIN</span></p>
<p class="textcenter"><em>The Return of the Player<br/>Among the Dead<br/>Under Radar<br/>Three Screenplays: The Player,<br/>The Rapture, The New Age</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_also.vue?48144a38